.root {
  align-items: center;
  border-radius: 6px;
  color: var(--color-foreground);
  cursor: pointer;
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding: 8px;
  text-decoration: none;
  transition: background-color 0.15s, color 0.15s;

  .icon {
    color: var(--color-foreground);
  }

  &:not(.root-is-active):hover {
    background: var(--color-sidebar-accent);
  }
}

.root-is-active {
  background: var(--color-sidebar-accent);
  font-weight: 500;
}

.icon {
  flex-shrink: 0;
}

.label {
  line-height: 1.3;
}
